import { wasmModule } from "../wasm/wasmModule";
import { IBiteReg }  from "../../common/types";


class BiteregModule {
    private _biteregModule:IBiteReg = null;


    constructor() {
       
    }

    public async SaveData(){
        this._biteregModule = wasmModule.moduleManager.GetModuleBiteReg();
        if(this._biteregModule){
           await new Promise<void>((resolve,reject)=>{
                this.saveDataResolve=resolve;
                this._biteregModule.SaveData();
            })
        }
    }

    public onBiteRegSaveDataFinished(){
        if(this.saveDataResolve){

            this.saveDataResolve();

        }
    }

    private saveDataResolve: (value: void | PromiseLike<void>) => void;

}


export const biteregModule = new BiteregModule();

